
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  title: 'Errors and Conditions',
  section: 'Errors and Conditions',
  layout: 'guide',
  description: 'Plaid Exchange error and messaging details'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const AggregatorSchema = makeShortcode("AggregatorSchema");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Errors and Exceptional Conditions' subtitle={metadata.description} mdxType="Header" />
    <h2 {...{
      "id": "communicating-errors"
    }}>{`Communicating errors`}</h2>
    <p>{`For certain predictable conditions, the implementer can return an `}<inlineCode parentName="p">{`ErrorResponse`}</inlineCode>{` and use the HTTP status code to communicate the cause of the error.`}</p>
    <h3 {...{
      "id": "response"
    }}>{`Response`}</h3>
    <h5 {...{
      "id": "errorresponse"
    }}><inlineCode parentName="h5">{`ErrorResponse`}</inlineCode></h5>
    <AggregatorSchema type='model' model='BasicErrorResponse' mdxType="AggregatorSchema" />
    <h5 {...{
      "id": "400-bad-request"
    }}>{`400 Bad Request`}</h5>
    <p>{`This response should be used to indicate that the parameters to the method were incorrect, e.g., the pagination parameters were out of range, or the dates were not specified in the correct format.`}</p>
    <h5 {...{
      "id": "401-unauthorized"
    }}>{`401 Unauthorized`}</h5>
    <p>{`This response should be used to indicate that the request requires authentication before it can be fulfilled. It should be returned when the request does not contain the required authentication methods: either an invalid/missing authentication token, or invalid credential pair in the case of the `}<a parentName="p" {...{
        "href": "/plaid-exchange/docs/reference/"
      }}>{`Authentication API Method`}</a>{` endpoint.`}</p>
    <h5 {...{
      "id": "503-service-unavailable"
    }}>{`503 Service Unavailable`}</h5>
    <p>{`This response should be used to indicate that the institution is currently unavailable to respond to the request. The implementer may return an `}<inlineCode parentName="p">{`InstitutionError`}</inlineCode>{` to indicate the time when it prefers that Plaid retries its requests.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "communicating-errors",
        level: 2,
        title: "Communicating errors",
      },
{
        id: "response",
        level: 3,
        title: "Response",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
